import { ActionType } from '../../abacus/enums/action-type.enum'
import { InputType } from '../../abacus/enums/input-type.enum'
import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceMode } from '../../abacus/enums/resource-mode.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'
import { Status } from '../../common/enums/status.enum'

export const toolDefinition: ResourceDefinition = {
  title: 'Tools',
  nameSingular: 'tool',
  namePlural: 'tools',
  className: 'Tool',
  mainIdentifier: 'name',
  slug: 'tools',
  path: 'tools',
  icon: 'icon-grid',
  hasDetailPage: true,
  hasListPage: true,
  buttons: [LinkType.CREATE],
  defaultLink: LinkType.DETAIL,
  childrenThatPreventDelete: [],
  dropdownLinks: [
    {
      label: 'Edit',
      permission: 'editTools',
      action: (tool) => ({
        type: ActionType.Link,
        link: {
          path: `${toolDefinition.path}/${tool.id}/edit`
        }
      })
    },
    {
      label: 'Delete',
      permission: 'deleteTools',
      action: (tool) => ({
        type: ActionType.Delete,
        delete: {
          itemToDelete: tool,
          definition: toolDefinition
        }
      })
    }
  ],
  actionButtons: [
    {
      label: 'Publish',
      className: 'button is-success p-x-lg is-small',
      permission: 'editTools',
      condition: (tool) => tool.status === Status.Pending,
      action: (tool) => ({
        type: ActionType.Patch,
        patch: {
          path: `tools/${tool.id}/status`,
          body: { status: Status.Published },
          successMessage: 'The tool has been published',
          errorMessage: 'Error: Tool could not be published',
          redirectTo: `tools/${tool.id}`
        }
      })
    },
    {
      label: 'Reject',
      className: 'button is-danger ml-2 p-x-lg is-small',
      condition: (tool) => tool.status === Status.Pending,
      action: (tool) => ({
        type: ActionType.OpenCreateEditModal,
        openCreateEditModal: {
          title: `Reject the submission`,
          helpText: `You can provide a reason for rejecting the submission.`,
          definition: toolDefinition,
          mode: ResourceMode.Patch,
          item: tool,
          patchURL: `tools/${tool.id}/status`,
          fields: [
            {
              label: 'Rejection comment',
              property: 'rejectReason',
              placeholder: 'Explain why you are rejecting this submission.',
              className: 'is-12',
              inputType: InputType.Textarea
            },
            {
              label: 'Status',
              property: 'status',
              forcedValue: Status.Rejected,
              inputType: InputType.Select,
              hidden: true
            }
          ],
          flashMessageOnSuccess: 'The tool has been rejected',
          flashMessageOnError: 'Error: Tool could not be rejected',
          redirectTo: `tools/${tool.id}`
        }
      })
    }
  ]
}
